import Cookies from "js-cookie";
import Pusher from "pusher-js";

// eslint-disable-next-line prefer-const
let pusherClient: Pusher | null = null;

export const getPusherClient = () => {
  if (pusherClient) {
    return pusherClient;
  }
  if (import.meta.env.NODE_ENV === "test") {
    return null;
  }
  if (import.meta.env.DEV) {
    Pusher.logToConsole = String(import.meta.env.VITE_PUSHER_SHOW_LOG) === "1";
  }
  pusherClient = new Pusher(import.meta.env.VITE_PUSHER_CLIENT_ID, {
    cluster: "us3",
    auth: { headers: { "X-CSRFToken": Cookies.get("csrftoken") } },
  });
  return pusherClient;
};
